import * as arrow from 'apache-arrow';
export function hardClone(data) {
  let force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if ('data' in data) {
    return new arrow.Vector(data.data.map(data => hardClone(data, force)));
  }
  const clonedChildren = [];
  for (const childData of data.children) {
    clonedChildren.push(hardClone(childData, force));
  }
  let clonedDictionary;
  if (data.dictionary !== undefined) {
    clonedDictionary = hardClone(data.dictionary, force);
  }
  const clonedBuffers = {
    [arrow.BufferType.OFFSET]: cloneBuffer(data.buffers[arrow.BufferType.OFFSET], force),
    [arrow.BufferType.DATA]: cloneBuffer(data.buffers[arrow.BufferType.DATA], force),
    [arrow.BufferType.VALIDITY]: cloneBuffer(data.buffers[arrow.BufferType.VALIDITY], force),
    [arrow.BufferType.TYPE]: cloneBuffer(data.buffers[arrow.BufferType.TYPE], force)
  };
  return new arrow.Data(data.type, data.offset, data.length, data._nullCount, clonedBuffers, clonedChildren, clonedDictionary);
}
export function isShared(data) {
  if ('data' in data) {
    return data.data.some(data => isShared(data));
  }
  for (const childData of data.children) {
    if (isShared(childData)) {
      return true;
    }
  }
  if (data.dictionary !== undefined) {
    if (isShared(data.dictionary)) {
      return true;
    }
  }
  const bufferTypes = [arrow.BufferType.OFFSET, arrow.BufferType.DATA, arrow.BufferType.VALIDITY, arrow.BufferType.TYPE];
  for (const bufferType of bufferTypes) {
    if (data.buffers[bufferType] !== undefined && isTypedArraySliced(data.buffers[bufferType])) {
      return true;
    }
  }
  return false;
}
function isTypedArraySliced(arr) {
  return !(arr.byteOffset === 0 && arr.byteLength === arr.buffer.byteLength);
}
function cloneBuffer(arr, force) {
  if (arr === undefined) {
    return arr;
  }
  if (!force && !isTypedArraySliced(arr)) {
    return arr;
  }
  return arr.slice();
}
//# sourceMappingURL=hard-clone.js.map